import { axiosSwagger } from "@/axios";

export const state = {
    approver: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // APPROVER
    loading: (state, loading) => {
        state.approver.loading = loading;
    },
    setData: (state, data) => {
        state.approver.data = data;
    },
    setTotal: (state, total) => {
        state.approver.total = total;
    },
    add: (state, data) => {
        state.approver.data.push(data);
    },
    remove: (state, id) => {
        state.approver.data = state.approver.data.filter((el) => el.id !== id);
    },
    update: (state, data) => {
        const index = state.approver.data.findIndex(
            (item) => item.id === data.id
        );

        if (index !== -1) {
            state.approver.data[index].approverId = data.approverId;
            state.approver.data[index].approver = data.approver;
        }
    },
    updateRemove: (state, id) => {
      const index = state.approver.data.findIndex(
          (item) => item.id === id
      );

      if (index !== -1) {
          state.approver.data[index].approverId = null;
          state.approver.data[index].approver = null;
      }
    },
    updateAdd: (state, data) => {
        const index = state.approver.data.findIndex(
            (item) => item.documentCategoryGroupId === data.documentCategoryGroupId
        );
  
        if (index !== -1) {
            state.approver.data[index].id = data.id;
            state.approver.data[index].approverId = data.approverId;
            state.approver.data[index].approver = data.approver;
        }
    },
}


export const actions = {
    // APPROVER
    async readApprover({ commit }, campusId) {
        commit("loading", true);

        return await axiosSwagger
        .get(`/api/ApproverSetting/All/${campusId}`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    async createApprover({ commit }, data) {
        return await axiosSwagger
        .post(`/api/ApproverSetting/Add/${data.campusId}`, data)
        .then((response) => {
            commit("updateAdd", response.data);

            return response;
        });
    },
    async deleteApprover({ commit }, id) {
        return await axiosSwagger
        .delete(`/api/ApproverSetting/${id}`)
        .then((response) => {
            commit("updateRemove", id);

            return response;
        });
    },
    async updateApprover({ commit }, data) {
        return await axiosSwagger
        .put(`/api/ApproverSetting/${data.id}`, data)
        .then((response) => {
            commit("update", data);

            return response;
        });
    },
}

